<template>
  <v-dialog v-model="dialog" width="90%">
    <v-card elevation="3">

      <div class="pp-sidenav">
        <div class="white--text text-h6 px-5 py-2">
          Publish an Awarding Body
        </div>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-plus
          </v-icon>
          Awarding Body Details
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Add Awarding Body Details
                  </v-card-title>

                  <div class="py-5 pa-3">
                    <v-card-text>
                      <v-row>
                        <v-text-field
                            v-model="add.name"
                            aria-required="true"
                            color="primary"
                            label="Awarding Body Title"
                            placeholder="Add an Awarding Body Title"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>
                      <v-row v-if="certificationBodyApiError && certificationBodyApiError.fields && certificationBodyApiError.fields.name" class="err-text">
                        <p class="error--text">
                          Awarding Body name should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row class="mb-5">
                        <v-textarea
                            v-model="add.description"
                            auto-grow
                            hint="The description of the Awarding Body will be publicly visible"
                            persistent-hint
                            aria-required="true"
                            color="primary"
                            label="Awarding Body Description"
                            placeholder="Add an Awarding Body Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        ></v-textarea>
                      </v-row>

                      <v-row v-if="certificationBodyApiError && certificationBodyApiError.fields && certificationBodyApiError.fields.description" class="err-text">
                        <p class="error--text">
                          Certification Body's description should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="add.image"/>

                      <TagsInput
                          v-model="add.tags"
                          :validationError="certificationBodyApiError"
                      />

                      <v-row v-if="certificationBodyApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </v-card-text>
                  </div>
                </v-card>
              </template>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">

          <Loading v-if="certificationBodyItemLoading" />

          <ConfirmCancelButtons
              :item="add"
              :cancel-action="closeDialog"
              :confirm-action="addItemConfirm"
              confirm-text="Create Awarding Body"
              :confirm-disabled="certificationBodyItemLoading"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters } from "vuex";
import ImagePicker from "@/components/common/ImagePicker";
import Loading from "@/components/common/Loading";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "CertificationBodyAdd",
  components: {
    TagsInput,
    Loading, ImagePicker, ConfirmCancelButtons,
  },
  data() {
    return {
      add: {
        name: '',
        description: '',
        image: undefined,
        tags: [],
      },
    };
  },
  computed: {
    ...mapGetters(['certificationBodyApiError', 'openDialog', 'certificationBodyItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'certificationBodyAdd';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['addCertificationBody', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.add = {
        name: '',
        description: '',
        image: undefined,
        tags: [],
      };
    },
    async addItemConfirm() {
      const added = await this.addCertificationBody(this.add);

      if (added) {
        this.closeOpenDialog();
        this.add  = {
          name: '',
          description: '',
          image: undefined,
          tags: [],
        };
      }
    },
  },
};
</script>
